import ConsumerUser from './ConsumerUser.png'
import LawyerUser from './LawyerUser.png'
import EnterpriseUser from './EnterpriseUser.png'

export const Section7Images = {
  ConsumerUser,
  LawyerUser,
  EnterpriseUser,
}
